// Simple state store with subscriptions
type Listener<T> = (state: T) => void;

export class Store<T> {
  private state: T;
  private listeners: Set<Listener<T>> = new Set();

  constructor(initialState: T) {
    this.state = initialState;
  }

  getState(): T {
    return this.state;
  }

  setState(newState: T | ((prev: T) => T)): void {
    const nextState = typeof newState === 'function' ? (newState as Function)(this.state) : newState;
    this.state = nextState;
    this.notify();
  }

  subscribe(listener: Listener<T>): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify(): void {
    this.listeners.forEach(listener => listener(this.state));
  }
}

// Global app state
export interface AppState {
  user: any | null;
  currentFamilyId: string | null;
  currentDeviceId: string | null;
  isLoading: boolean;
  error: string | null;
}

export const appStore = new Store<AppState>({
  user: null,
  currentFamilyId: null,
  currentDeviceId: null,
  isLoading: false,
  error: null,
});
